<template>
  <div class="modal" :class="{'is-active': opened}">
    <div class="modal-background"></div>
    <div class="modal-card wide-modal">
      <header class="modal-card-head">
        <p class="modal-card-title">Upload inbound shipment items</p>
        <button class="delete" @click="close"></button>
      </header>
      <section class="modal-card-body">
        <div v-if="waiting">
          <span class="icon is-medium is-size-4">
            <i class="fas fa-spinner fa-pulse"></i>
          </span>
        </div>
        <div v-if="error" class="notification is-danger is-light">
          {{error}}
        </div>

        <div v-if="items">
          <div class="columns">
              <div class="column">
                <h1 class="title is-5">Inbound shipment items</h1>
              </div>
              <div class="column">
                <div class="field">
                  <p class="control has-icons-left">
                    <input class="input" type="text" placeholder="Search" v-model="search">
                    <span class="icon is-small is-left">
                      <i class="fas fa-search"></i>
                    </span>
                  </p>
                </div>
              </div>
            </div>
          <table class="table is-hoverable is-fullwidth">
            <thead>
              <tr>
                <th>
                  <span class="is-clickable" @click="changeSortOption('poLine')">PO line</span>
                  <span class="icon" v-if="itemsSort.field == 'poLine'">
                    <i class="fas" :class="{'fa-sort-up': itemsSort.asc, 'fa-sort-down': !itemsSort.asc}"></i>
                  </span>
                </th>
                <th>
                  <span class="is-clickable" @click="changeSortOption('poItem.itemName')">Name</span>
                  <span class="icon" v-if="itemsSort.field == 'poItem.itemName'">
                    <i class="fas" :class="{'fa-sort-up': itemsSort.asc, 'fa-sort-down': !itemsSort.asc}"></i>
                  </span>
                </th>
                <th>
                  <span class="is-clickable" @click="changeSortOption('poItem.description')">Description</span>
                  <span class="icon" v-if="itemsSort.field == 'poItem.description'">
                    <i class="fas" :class="{'fa-sort-up': itemsSort.asc, 'fa-sort-down': !itemsSort.asc}"></i>
                  </span>
                </th>
                <th class="num-cell">
                  <span class="is-clickable" @click="changeSortOption('poItem.quantity')">PO quantity</span>
                  <span class="icon" v-if="itemsSort.field == 'poItem.quantity'">
                    <i class="fas" :class="{'fa-sort-up': itemsSort.asc, 'fa-sort-down': !itemsSort.asc}"></i>
                  </span>
                </th>
                <th class="num-cell">
                  <span class="is-clickable" @click="changeSortOption('shipmentQuantity')">Shipment quantity</span>
                  <span class="icon" v-if="itemsSort.field == 'shipmentQuantity'">
                    <i class="fas" :class="{'fa-sort-up': itemsSort.asc, 'fa-sort-down': !itemsSort.asc}"></i>
                  </span>
                </th>
                <th>
                  <span class="is-clickable" @click="changeSortOption('shipmentContainer')">Container</span>
                  <span class="icon" v-if="itemsSort.field == 'shipmentContainer'">
                    <i class="fas" :class="{'fa-sort-up': itemsSort.asc, 'fa-sort-down': !itemsSort.asc}"></i>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in showingItems" :key="'items-'+i">
                <td>{{item.po.tranId + ' - ' + item.poItem.line}}</td>
                <td>{{item.poItem.itemName}}</td>
                <td>{{item.poItem.description}}</td>
                <td class="num-cell">{{ item.poItem.quantity }}</td>
                <td class="num-cell">{{ item.shipmentQuantity }}</td>
                <td>{{ item.shipmentContainer }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th>Total</th>
                <th></th>
                <th></th>
                <th></th>
                <th class="num-cell">{{ quantitiesTotal }}</th>
                <th></th>
              </tr>
            </tfoot>
          </table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <a class="button is-link" :class="{'is-loading': waiting}" :disabled="!isValid" @click="saveInboundItems">Save</a>
        <a class="button" @click="close">Cancel</a>
      </footer>
    </div>
  </div>
</template>

<script>

function getFieldValue (obj, path) {

  var ss = path.split('.')
  var value = obj[ss[0]]
  var i = 1
  while (i < ss.length && value) {
    value = value[ss[i]]
    i += 1
  }
  return value
}

export default {
  name: 'upload-inbound-items-modal',
  props: ['opened', 'pos', 'inbound', 'records'],
  data () {
    return {
      error: '',
      waiting: false,
      items: null,
      locationId: '',
      poId: '',
      po: null,
      poMap: {},
      poItems: null,
      poItemsMap: {},
      itemsSort: {field: 'poLine', asc: true},
      poItem: null,
      currentInboundItems: [],
      shipmentContainer: '',
      quantitiesMap: {},
      search: '',
    }
  },
  computed: {
    server () {
      return this.$store.state.config.server
    },
    isValid () {
      var total = this.items && this.items.reduce((s, i) => s + i.shipmentQuantity, 0)
      return Boolean(total)
    },
    showingItems () {
      if (!this.items) {
        return []
      }
      var s = this.search.toLowerCase()
      var filteredItem = this.items.filter(i => i.po.tranId.toLowerCase().includes(s) || i.poItem.itemName.toLowerCase().includes(s)
        || i.poItem.description.toLowerCase().includes(s) || i.shipmentContainer.toLowerCase().includes(s))

      var field = this.itemsSort.field
      var asc = this.itemsSort.asc
      var sortedItems = filteredItem.sort((a, b) => {
        if (field == 'poLine') {
          if (a.po.tranId != b.po.tranId) {
            return asc ? a.po.tranId.localeCompare(b.po.tranId) :  b.po.tranId.localeCompare(a.po.tranId)
          }
          return asc ? (a.poItem.line - b.poItem.line) : (b.poItem.line - a.poItem.line)
        }

        var va = getFieldValue(a, field)
        var vb = getFieldValue(b, field)
        if (field == 'poItem.quantity' || field == 'shipmentQuantity') {
          return asc ? va - vb : vb - va
        }
        return asc ? va.localeCompare(vb) : vb.localeCompare(va)
      })
      return sortedItems
    },
    quantitiesTotal () {
      var total = this.showingItems.reduce((s, i) => s + i.shipmentQuantity, 0)
      return total
    },
  },
  watch: {
    opened (val) {
      if (val) {
        this.error = ''
        this.currentInboundItems = this.inbound.items.slice()
        this.items = null
        if (!this.records || !this.records.length) {
          this.error = 'No records found'
        } else {
          this.processRecords()
        }
      }
    },
  },
  methods: {
    close () {
      this.$emit('closeUploadInboundItemsModal')
    },
    saveInboundItems () {
      if (!this.items) {
        return
      }
      this.$emit('closeUploadInboundItemsModal', this.items.slice())
    },
    processRecords () {
      var rs = []
      var posMap = {}
      var poItemsMap = {}
      var locationId = null
      if (this.inbound.items && this.inbound.items.length) {
        var item = this.inbound.items[0]
        var po = this.pos.find(p => p.id == item.poId)
        if (!po) {
          this.error = 'First PO not found: ' + item.poId
          return
        }
        locationId = po.locationId
      }
      for (var r of this.records) {
        var tranId = r['PO'] && r['PO'].trim()
        var line = r['Line'] && parseInt(r['Line'].trim())
        var container = r['Container'] && r['Container'].trim()
        var quantity = r['Quantity'] && parseInt(r['Quantity'].trim())
        if (!tranId || !line || !container || !quantity) {
          this.error = 'Invalid record: ' + JSON.stringify(r)
          return
        }
        rs.push({tranId, line, container, quantity})
        var po = this.pos.find(p => p.tranId == tranId)
        if (!po) {
          this.error = 'PO not found: ' + tranId
          return
        }
        if (locationId) {
          if (po.locationId != locationId) {
            this.error = 'PO location mismatch: ' + tranId + ' - ' + po.locationId + ' vs ' + locationId
            return
          }
        } else {
          locationId = po.locationId
        }
        posMap[tranId] = po
        poItemsMap[tranId] = {}
      }
      var vm = this
      var promises = Object.keys(poItemsMap).map(tranId => {
        var po = posMap[tranId]
        return this.$http.get(this.server + '/myapp/get-purchase-order-items-with-inbounds/' + po.id).then(resp => {
          var poItems = resp.body.map(i => {
            vm.makeupRemaining(i)
            return i
          })
          for (var i of poItems) {
            var line = i.line
            poItemsMap[tranId][line] = i
          }
        })
      })
      vm.waiting = true
      Promise.all(promises).then(() => {
        vm.makeItems(rs, posMap, poItemsMap)
        vm.waiting = false
      }).catch(err => {
        vm.waiting = false
      })
    },
    makeupRemaining(i) {
      var quantity = i.quantity
      var remaining = quantity - i.quantityReceived
      if (remaining <= 0) {
        remaining = 0
      } else {
        remaining = quantity
        for (var ib of i.inbounds) {
          if (ib.inbound.id != this.inbound.id) {
            remaining -= ib.inboundItem.quantityExpected
          }
        }
      }
      i.remaining = remaining
    },
    makeRemainingsMap (poItemsMap) {
      var remainingsMap = {}
      for (var tranId in poItemsMap) {
        var poItems = poItemsMap[tranId]
        for (var line in poItems) {
          var poItem = poItems[line]
          var remaining = poItem.remaining
          if (remaining > 0) {
            for (var ibi of this.currentInboundItems) {
              if (ibi.po.tranId != tranId) {
                continue
              }
              if (ibi.shipmentItemName == poItem.itemName.split(':')[1].trim() && ibi.shipmentItemDescription.trim() == poItem.description.trim()) {
                remaining -= ibi.quantityExpected
              }
            }
          }
          remainingsMap[tranId + '-' +  line] = remaining
        }
      }
      return remainingsMap
    },
    makeItems (records, posMap, poItemsMap) {
      var remainingsMap = this.makeRemainingsMap(poItemsMap)
      var items = []
      for (var r of records) {
        var po = posMap[r.tranId]
        var remaining = remainingsMap[r.tranId + '-' + r.line] - r.quantity
        if (remaining < 0) {
          this.error = 'Shipment quantity exceeds maximum quantity: ' + JSON.stringify(r)
          return
        }
        remainingsMap[r.tranId + '-' + r.line] = remaining
        var poItem = poItemsMap[r.tranId][r.line]
        items.push({
          po: po,
          poItem: poItem,
          shipmentContainer: r.container,
          shipmentQuantity: r.quantity,
          shipmentItemClass: poItem.className,
        })
      }
      this.items = items
    },
    changeSortOption (field) {
      this.itemsSort = {
        field: field,
        asc: field == this.itemsSort.field ? !this.itemsSort.asc : true
      }
    },
  },
}
</script>

<style scoped>
.wide-modal {
  width: 800px!important;
}
.num-cell {
  text-align: right !important;
}
</style>
